import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusProgramConfigQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusProgramConfigQuery = { readonly __typename?: 'Query', readonly programConfig?: { readonly __typename?: 'EpocusProgramConfig', readonly id: string, readonly enabledExamTypes: ReadonlyArray<Types.EpocusExamType> } | null };

export type EpocusSetProgramEnabledExamTypesMutationVariables = Types.Exact<{
  input: Types.SetEpocusProgramEnabledExamTypesInput;
}>;


export type EpocusSetProgramEnabledExamTypesMutation = { readonly __typename?: 'Mutation', readonly setEpocusProgramEnabledExamTypes: { readonly __typename?: 'EpocusProgram', readonly id: string, readonly config?: { readonly __typename?: 'EpocusProgramConfig', readonly id: string, readonly enabledExamTypes: ReadonlyArray<Types.EpocusExamType> } | null } };


export const EpocusProgramConfigDocument = gql`
    query EpocusProgramConfig($programId: ID!) {
  programConfig(programId: $programId) {
    id
    enabledExamTypes
  }
}
    `;

/**
 * __useEpocusProgramConfigQuery__
 *
 * To run a query within a React component, call `useEpocusProgramConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusProgramConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusProgramConfigQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusProgramConfigQuery(baseOptions: Apollo.QueryHookOptions<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>(EpocusProgramConfigDocument, options);
      }
export function useEpocusProgramConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>(EpocusProgramConfigDocument, options);
        }
export type EpocusProgramConfigQueryHookResult = ReturnType<typeof useEpocusProgramConfigQuery>;
export type EpocusProgramConfigLazyQueryHookResult = ReturnType<typeof useEpocusProgramConfigLazyQuery>;
export type EpocusProgramConfigQueryResult = Apollo.QueryResult<EpocusProgramConfigQuery, EpocusProgramConfigQueryVariables>;
export const EpocusSetProgramEnabledExamTypesDocument = gql`
    mutation EpocusSetProgramEnabledExamTypes($input: SetEpocusProgramEnabledExamTypesInput!) {
  setEpocusProgramEnabledExamTypes(input: $input) {
    id
    config {
      id
      enabledExamTypes
    }
  }
}
    `;
export type EpocusSetProgramEnabledExamTypesMutationFn = Apollo.MutationFunction<EpocusSetProgramEnabledExamTypesMutation, EpocusSetProgramEnabledExamTypesMutationVariables>;

/**
 * __useEpocusSetProgramEnabledExamTypesMutation__
 *
 * To run a mutation, you first call `useEpocusSetProgramEnabledExamTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusSetProgramEnabledExamTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusSetProgramEnabledExamTypesMutation, { data, loading, error }] = useEpocusSetProgramEnabledExamTypesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusSetProgramEnabledExamTypesMutation(baseOptions?: Apollo.MutationHookOptions<EpocusSetProgramEnabledExamTypesMutation, EpocusSetProgramEnabledExamTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusSetProgramEnabledExamTypesMutation, EpocusSetProgramEnabledExamTypesMutationVariables>(EpocusSetProgramEnabledExamTypesDocument, options);
      }
export type EpocusSetProgramEnabledExamTypesMutationHookResult = ReturnType<typeof useEpocusSetProgramEnabledExamTypesMutation>;
export type EpocusSetProgramEnabledExamTypesMutationResult = Apollo.MutationResult<EpocusSetProgramEnabledExamTypesMutation>;
export type EpocusSetProgramEnabledExamTypesMutationOptions = Apollo.BaseMutationOptions<EpocusSetProgramEnabledExamTypesMutation, EpocusSetProgramEnabledExamTypesMutationVariables>;